import { track } from "~/modules/analytics/track";
import { AssetUserEvents } from "../analytics/events/assets";

// // // //

/**
 * trackExpandTableRow
 * Tracks the `ExpandTableRow` event
 */
export function trackExpandTableRow(props: { assetName: string }) {
    track(AssetUserEvents.ExpandTableRow, props);
}

/**
 * trackCollapseTableRow
 * Tracks the `CollapseTableRow` event
 */
export function trackCollapseTableRow(props: { assetName: string }) {
    track(AssetUserEvents.CollapseTableRow, props);
}

/**
 * trackTransactionsTabChange
 * Tracks the event when a user changes a tab in the AssetTransactions component
 */
export function trackTransactionsTabChange(props: {
    prev: string;
    next: string;
    asset_id: number;
    asset_ticker: string;
}) {
    track(AssetUserEvents.TransactionsChangeTab, props);
}
